import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/kiloposts'))
  },
  getKilopostsShutokou() {
    return axios.get(utils.getApiUrl('/kiloposts-shutokou'))
  },
  getKilopostsHokuriku() {
    return axios.get(utils.getApiUrl('/kiloposts-hokuriku'))
  },
  getKilopostsARC() {
    return axios.get(utils.getApiUrl('/kiloposts-arc'))
  },
  getKilopostsNagoya() {
    return axios.get(utils.getApiUrl('/kiloposts-nagoya'))
  },
  getKilopostsNexcoEastNiigata() {
    return axios.get(utils.getApiUrl('/kiloposts-nexco-east-niigata'))
  },
  getKilopostsNexcoEastSaitama() {
    return axios.get(utils.getApiUrl('/kiloposts-nexco-east-saitama'))
  },
  getKilopostsShikoku() {
    return axios.get(utils.getApiUrl('/kiloposts-shikoku'))
  },
  getKilopostsChisei(chiseiName) {
    return axios.get(utils.getApiUrl(`/kiloposts-chisei/${chiseiName}`))
  },
  getKilopostsKendo(kendoName) {
    return axios.get(utils.getApiUrl(`/kiloposts-kendo/${kendoName}`))
  },
  getKilopostsFukuokaKitakyushu() {
    return axios.get(utils.getApiUrl('/kiloposts-fukuoka-kitakyushu'))
  },
  getKilopostsHonshi() {
    return axios.get(utils.getApiUrl('/kiloposts-honshi'))
  },
  getKilopostsHitachiKasen() {
    return axios.get(utils.getApiUrl('/kiloposts-hitachi-kasen'))
  },
  getKilopostsKoufuKasen() {
    return axios.get(utils.getApiUrl('/kiloposts-koufu-kasen'))
  },
  getKilopostsMiyagi() {
    return axios.get(utils.getApiUrl('/kiloposts-miyagi'))
  },
  getKilopostsTokyu() {
    return axios.get(utils.getApiUrl('/kiloposts-tokyu'))
  },
  getKilopostsHiroshimaAirport() {
    return axios.get(utils.getApiUrl('/kiloposts-hiroshima-airport'))
  },
  getKilopostsShinchitoseAirport() {
    return axios.get(utils.getApiUrl('/kiloposts-shinchitose-airport'))
  },
  getKilopostsIwaki() {
    return axios.get(utils.getApiUrl('/kiloposts-iwaki'))
  },
  getKilopostsYurikamome() {
    return axios.get(utils.getApiUrl('/kiloposts-yurikamome'))
  },
  getKilopostsGunma() {
    return axios.get(utils.getApiUrl('/kiloposts-gunma'))
  },
  getKilopostsKantouMC() {
    return axios.get(utils.getApiUrl('/kiloposts-kantou-mc'))
  },
  getKilopostsNagano() {
    return axios.get(utils.getApiUrl('/kiloposts-nagano'))
  },
}
